<div class="container-fluid fluid2 print" style="margin:1rem 0">
    <div class="div_loading">
        <div class="my-container" [hidden]="!loading">
            <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
        </div>
    </div>

    <section class="container-fluid invoice">
        <div class="row containerInier">
            <div class="row" style="padding:15px">
                <!-- ************************************************************************************************************  -->
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <p>
                        مدیر پروژه محترم
                    </p>
                    <p>
                        با سلام
                    </p>
                    <p style="margin-top:1.5rem">
                        احتراما، پیرو مذاکرات قبلی موارد زیر تقدیم حضورتان می گردد.
                    </p>
                </div>

                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <ul>
                        <li> قیمت ها صرفا شامل متریال پیوست می باشد. </li>
                        <li> قیمت به ازای هر متر مربع {{ amount | number }} تومان برآورد میگردد. </li>
                        <li> متراژ براساس میانگین پشت تا پشت نما محاسبه می گردد .</li>
                        <li>
                            در قیمت اعلام شده اسباب تخلیه و بارگیری،تجهیز کارگاه،حمل بر عهده فروشنده وکسورات قانونی بر
                            عهده
                            کارفرما می باشد
                        </li>
                        <li>اعتبار قیمت یک ماه از تاریخ صدور می باشد.</li>
                    </ul>
                </div>

                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 sign">
                    با تقدیم احترام
                    شرکت هوشمند سازه
                </div>
                <!-- ************************************************************************************************************ -->
            </div>
        </div>
    </section>
    <footer class="container-fluid footer">
        <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <span class="noprint" style="float: left;">
                    <a href="javascript:window.print()" class="btn btn-default print-button"><i
                            class="icon-printer"></i> پرینت</a>
                </span>
            </div>
        </div>
    </footer>
</div>